module.exports = __webpack_public_path__ + "img/no-data.2b400360.svg";